export const enum CarBodyType {
  Van = 'van',
  LCV_S_GLOBAL = 'lcv_s_global',
  LCV_M = 'lcv_m',
  LCV_M_GLOBAL = 'lcv_m_global',
  LCV_L = 'lcv_l',
  LCV_L_GLOBAL = 'lcv_l_global',
  LCV_XL = 'lcv_xl',
  TRUCK_5T = 'truck_5t',
}

export type Props = {
  name: string
  getFallbackValue(value: string): string | undefined
}
